import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewDraft: {
		id: 'servicedesk-knowledge-performance.suggested-topics-table.create-article.view-draft',
		defaultMessage: 'View draft',
		description: 'View draft button text',
	},
});
